import { roles } from "../config/config";

export const arubaMailPermissions = [
  roles.admin,
  roles.gestore,
  roles.developer,
  roles.magazziniere,
  roles.contabile,
  roles.grafico,
  roles.agenteRoydermal,
  roles.agenteRoypet,
  roles.agenteCompleto,
];

export const epsMailPermissions = [
  roles.admin,
  roles.gestore,
  roles.developer,
  roles.magazziniere,
  roles.contabile,
  roles.grafico,
  roles.agenteValderma,
];
